import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface AlphabetNavProps {
  activeLetters: string[];
  activeLetter: string | null;
  onLetterClick: (letter: string) => void;
}

export const AlphabetNav = ({ activeLetters, activeLetter, onLetterClick }: AlphabetNavProps) => {
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

  return (
    <div className="sticky top-20 z-10 bg-background/95 backdrop-blur-sm border-b border-border py-4">
      <div className="container">
        <div className="flex flex-wrap gap-1 justify-center">
          {alphabet.map((letter) => {
            const isActive = activeLetters.includes(letter);
            const isSelected = activeLetter === letter;
            
            return (
              <Button
                key={letter}
                variant={isSelected ? "default" : isActive ? "outline" : "ghost"}
                size="sm"
                className={cn(
                  "w-9 h-9 p-0 text-sm font-semibold",
                  !isActive && "opacity-30 cursor-not-allowed",
                  isSelected && "bg-primary text-primary-foreground"
                )}
                onClick={() => isActive && onLetterClick(letter)}
                disabled={!isActive}
              >
                {letter}
              </Button>
            );
          })}
        </div>
      </div>
    </div>
  );
};
